import React, { useState } from 'react';
import './Pagination.css';

const buildPages = (currentPage, totalPages) => {
  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) pages.push(i);
    return pages;
  }

  pages.push(1);
  if (currentPage > 3) pages.push('start-ellipsis');
  for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i += 1) {
    pages.push(i);
  }
  if (currentPage < totalPages - 2) pages.push('end-ellipsis');
  pages.push(totalPages);
  return pages;
};

const Pagination = ({ pagination, currentPage, onPageChange, unitLabel = '筆' }) => {
  const [jumpPage, setJumpPage] = useState('');
  const totalPages = Math.max(1, Number(pagination?.pages || 1));
  const total = Number(pagination?.total || 0);
  const page = Math.min(Math.max(1, Number(currentPage || pagination?.page || 1)), totalPages);

  if (totalPages <= 1) return null;

  const goToJumpPage = () => {
    const target = Number.parseInt(jumpPage, 10);
    if (target >= 1 && target <= totalPages) {
      onPageChange(target);
      setJumpPage('');
    }
  };

  return (
    <div className="pagination">
      <button className="btn-pagination" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>‹ 上一頁</button>
      <div className="page-numbers">
        {buildPages(page, totalPages).map((item, idx) => (
          typeof item === 'string' ? (
            <span key={`${item}-${idx}`} className="page-ellipsis">…</span>
          ) : (
            <button key={item} className={`page-number ${page === item ? 'active' : ''}`} onClick={() => onPageChange(item)}>{item}</button>
          )
        ))}
      </div>
      <button className="btn-pagination" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>下一頁 ›</button>
      {totalPages > 6 && (
        <div className="page-jump">
          <input
            type="number"
            className="page-jump-input"
            min="1"
            max={totalPages}
            placeholder="頁碼"
            value={jumpPage}
            onChange={(e) => setJumpPage(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') goToJumpPage(); }}
          />
          <button className="btn-pagination btn-go" onClick={goToJumpPage}>前往</button>
        </div>
      )}
      <span className="page-info">共 {total} {unitLabel} / {totalPages} 頁</span>
    </div>
  );
};

export default Pagination;
